import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { ISignUpRequest } from "@faire/web-api--source/indigofair/data/ISignUpRequest";
export var BUSINESS_TYPE;
(function(BUSINESS_TYPE) {
    BUSINESS_TYPE["POP_UP_STORE"] = "Pop-up Store";
    BUSINESS_TYPE["ONLINE_ONLY"] = "Online Only";
    BUSINESS_TYPE["BRICK_AND_MORTAR_SHOP"] = "Brick & Mortar Store";
    BUSINESS_TYPE["OTHER"] = "Other";
    BUSINESS_TYPE["CONSUMER"] = "I Don't Have a Store";
})(BUSINESS_TYPE || (BUSINESS_TYPE = {}));
var _obj;
export var BUSINESS_TYPE_REVAMP = (_obj = {}, _define_property(_obj, ISignUpRequest.BusinessPlatform.POP_UP, BUSINESS_TYPE.POP_UP_STORE), _define_property(_obj, ISignUpRequest.BusinessPlatform.ONLINE_ONLY, BUSINESS_TYPE.ONLINE_ONLY), _define_property(_obj, ISignUpRequest.BusinessPlatform.BRICK_AND_MORTAR, BUSINESS_TYPE.BRICK_AND_MORTAR_SHOP), _define_property(_obj, ISignUpRequest.BusinessPlatform.OTHER_PLATFORM, BUSINESS_TYPE.OTHER), _define_property(_obj, ISignUpRequest.BusinessPlatform.BUSINESS_PLATFORM_UNKNOWN, "Unknown"), _obj);
